@if (gatewayChipId != null) {
  <div class="field has-addons">
    <div class="control is-expanded">
      <input class="input" [value]="gatewayChipId" disabled>
    </div>
    <div class="control">
      <button type="button" class="button is-light" (click)="ClearGateway()">
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>
}
@if (gatewayChipId == null) {
  <div class="ng-autocomplete position" style="width:100%;" (keypress)="KeyPress($event)">
    <ng-autocomplete [data]="searchResults" [searchKeyword]="searchTerm" placeholder="Select Gateway"
      (selected)='ItemSelected($event)' (inputChanged)='SearchChanged($event)' [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate" [debounceTime]="300" [isLoading]="isLoading" (inputCleared)="Cleared()">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a>{{ 'Chip Id: '+item.ChipId }}</a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
      <div>{{ notFound }}</div>
    </ng-template>
  </div>
}